import { GetQuoteMutationInput } from "src/configs/APISchemas/GetQuote";
import { getStringValuesObject } from "src/pages/payment-msi/utils/get-string-values-object.util";
import { PurchasePolicyInput, PurchasePolicyAdditionalData } from "src/redux/reducer/v2/purchasePolicy";

export type GetQuoteMutationSerializerArgs = {
  purchasePolicyInput: PurchasePolicyInput;
  purchasePolicyAdditionalData: PurchasePolicyAdditionalData;
};

export function getQuoteMutationSerializer({
  purchasePolicyInput,
  purchasePolicyAdditionalData,
}: GetQuoteMutationSerializerArgs): GetQuoteMutationInput {
  const { id, communityId } = purchasePolicyAdditionalData;
  const {
    deductible,
    medicalPayments,
    personalPropertyCoverage,
    personalLiabilityCoverage,
    lossOfUse,
    theft,
    windHail,
    waterBackup,
    petDamage,
    identityFraud,
    optionalCoverages,
    earthquake,
    hurricane,
  } = purchasePolicyInput;

  const stringValuesObject = getStringValuesObject({
    communityId,
    deductible,
    medicalPayments,
    personalPropertyCoverage,
    personalLiabilityCoverage,
    lossOfUse,
    theft,
    windHail,
    waterBackup,
    petDamage,
    identityFraud,
  });

  return {
    id,
    communityId: stringValuesObject.communityId,
    deductible: stringValuesObject.deductible,
    medicalPayments: stringValuesObject.medicalPayments,
    personalPropertyCoverage: stringValuesObject.personalPropertyCoverage,
    personalLiabilityCoverage: stringValuesObject.personalLiabilityCoverage,
    lossOfUse: stringValuesObject.lossOfUse,
    theft: stringValuesObject.theft,
    windHail: stringValuesObject.windHail,
    waterBackup: stringValuesObject.waterBackup,
    petDamage: stringValuesObject.petDamage,
    identityFraud: stringValuesObject.identityFraud,
    fireDepartmentService: optionalCoverages.fireDepartmentService,
    sinkHole: optionalCoverages.sinkHole,
    ordinanceOrLaw: optionalCoverages.ordinanceOrLaw,
    rentalIncome: optionalCoverages.rentalIncome,
    workersCompensation: optionalCoverages.workersCompensation,
    earthquake: earthquake,
    hurricane: hurricane,
  };
}
